module.exports = __webpack_public_path__ + "img/fabricBanner.0109518b.jpg";